const initTitle = () => {
	const sections = document.querySelectorAll( 'section.title' );

	if ( sections.length ) {
		Array.from( sections ).forEach( ( section ) => {
			const headerText = section.querySelector( 'header > p' );
			if ( headerText ) {
				if ( headerText.innerText === "Способы покупки" && section.nextElementSibling.classList.contains( 'list' ) ) {
					section.classList.add( 'change-background' );
					section.nextElementSibling.classList.add( 'change-background' );
				}
			}
		}) 
	}
}

export {
	initTitle,
};